import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const ResetPasswordLoadable = Loadable({
    loader: () => import('desktop/containers/ResetPassword/ResetPassword.js' /* webpackChunkName: 'resetPassword' */).then(module => module.default),
    loading: () => <Loader />
});

export default ResetPasswordLoadable;
